export default "__VITE_ASSET__79cef62b__"